export const freezeErrors = {
  target: '',
  memo_text: '',
}

export const defaultFreeze = {
  issuer: '',
  target: '',
  asset_code: '',
  memo_text: '',
}
